import React, { useState, useEffect } from "react";

const Timer = ({ delayResend = 180, onTimeout, phoneNumber = "" }: any) => {
  const [delay, setDelay] = useState(delayResend);
  const [phone, setPhone] = useState(phoneNumber);
  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);

    if (phone != phoneNumber) {
      setDelay(delayResend);
      setPhone(phoneNumber);
    }

    if (delay === 0) {
      onTimeout(true);
      clearInterval(timer);
      setDelay(180);
    }

    return () => {
      clearInterval(timer);
    };
  });

  return (
    <>
      <span>
        0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </span>
    </>
  );
};

export default Timer;
